'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dAgent$002dView$0024$0024anon$002426 from "./presto.-Agent-View$$anon$26.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024 from "./presto.types$-Base64-String$.js";
import * as $j_presto$002etypes$0024$002dSome$002dHash$0024 from "./presto.types$-Some-Hash$.js";
import * as $j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64$0024 from "./presto.types$proto$-Unsigned-File-Base64$.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$25() {
  this.axM = null;
  this.axE = null;
  this.axF = false;
  this.axN = null;
  this.axO = false;
  this.axR = null;
  this.axK = null;
  this.axL = false;
  this.axG = null;
  this.axH = false;
  this.axI = null;
  this.axJ = false;
  this.axP = false;
  this.axQ = false;
  this.axM = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.axR = "UnsignedFileBase64";
}
export { $c_Lpresto_AgentView$$anon$25 as $c_Lpresto_AgentView$$anon$25 };
$p = $c_Lpresto_AgentView$$anon$25.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$25;
/** @constructor */
function $h_Lpresto_AgentView$$anon$25() {
}
export { $h_Lpresto_AgentView$$anon$25 as $h_Lpresto_AgentView$$anon$25 };
$h_Lpresto_AgentView$$anon$25.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.axM;
});
$p.M = (function() {
  if ((!this.axF)) {
    this.axE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.axF = true;
  }
  return this.axE;
});
$p.O = (function() {
  if ((!this.axO)) {
    this.axN = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.axO = true;
  }
  return this.axN;
});
$p.E = (function() {
  return this.axR;
});
$p.t = (function() {
  if ((!this.axL)) {
    this.axK = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("content", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.axL = true;
  }
  return this.axK;
});
$p.N = (function() {
  if ((!this.axH)) {
    this.axG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dSome$002dHash$0024.$m_Lpresto_types$SomeHash$().a2o(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dBase64$002dString$0024.$m_Lpresto_types$Base64String$().qX(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.axH = true;
  }
  return this.axG;
});
$p.Q = (function() {
  if ((!this.axJ)) {
    this.axI = new $j_presto$002e$002dAgent$002dView$0024$0024anon$002426.$c_Lpresto_AgentView$$anon$26();
    this.axJ = true;
  }
  return this.axI;
});
$p.v = (function() {
  if ((!this.axQ)) {
    this.axP = false;
    this.axQ = true;
  }
  return this.axP;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee176) => ((p) => \u03b4scrutinee176.cGu(p)))($j_presto$002etypes$0024proto$0024$002dUnsigned$002dFile$002dBase64$0024.$m_Lpresto_types$proto$UnsignedFileBase64$())));
});
var $d_Lpresto_AgentView$$anon$25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$25, "presto.AgentView$$anon$25", ({
  DM: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_AgentView$$anon$25 as $d_Lpresto_AgentView$$anon$25 };
//# sourceMappingURL=presto.-Agent-View$$anon$25.js.map
